(() => {
    window.Dashboard = window.Dashboard || {};

    window.Dashboard.Models = window.Dashboard.Models || {};
    window.Dashboard.Models.Lookups = window.Dashboard.Models.Lookups || {};

    /**
     * Lookup for campaign actions
     * @constructor
     */
    window.Dashboard.Models.Lookups.DateRules = {
        All: 1,
        FirstDateOfMonth: 2,
        LastDayOfMonth: 3,
        WeekDay: 4,
        WeekendDay: 5
    };
})();
